import {
    Avatar,
    Badge,
    TableBody,
    TableCell,
    TableRow,
  } from "@windmill/react-ui";
  import MainDrawer from "components/drawer/MainDrawer";
  import ServiceServices from "services/ServiceServices";
  import ServiceDrawer from "components/drawer/ServiceDrawer";
  import CheckBox from "components/form/CheckBox";
  import DeleteModal from "components/modal/DeleteModal";
  import EditDeleteButton from "components/table/EditDeleteButton";
  import ShowHideButton from "components/table/ShowHideButton";
  import Tooltip from "components/tooltip/Tooltip";
  import useToggleDrawer from "hooks/useToggleDrawer";
  import { t } from "i18next";
  import { FiZoomIn } from "react-icons/fi";
  import { Link } from "react-router-dom";
  import { showingTranslateValue } from "utils/translate";
  import React, { useState, useEffect } from 'react'
  //internal import  
  const UserTable = ({
    setId,
    searchUser,
    isCheck,
    setIsCheck,
    currency,
    lang,
    data,
    isLoading,
    setIsLoading,
  }) => {
    const { handleModalOpen, serviceId, handleUpdate } = useToggleDrawer();
  
    const handleClick = (id) => {
      console.log(isCheck);
      if (isCheck.includes(id)) {
  
      setIsCheck(isCheck.filter((item) => item !== id));
        } else {
      setIsCheck(  [...isCheck, id]);
        }
    
    };
  
    return (
      <>
        <TableBody>
          {data?.map((item, i) => (
            <TableRow key={i + 1}>
              <TableCell>
                <CheckBox
                  id={item.email}
                  name={item.title_en}
                  type="checkbox"
                  // handleClick={() => handleClick(item.id)}
                  isChecked={isCheck?.includes(item.email)}
                  setIsCheck={setIsCheck}
  
                />
              </TableCell>
              <TableCell>
                <div className="flex items-center">
                  <h2 className="text-sm font-medium">{i+1}</h2>
                </div>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium">{item.name}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium">{item.phone}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium">{item.email}</span>
              </TableCell>
              <TableCell>
                <span className="text-sm font-medium">{item.tax_number? item.tax_number:'__'}</span>
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </>
    );
  };
  
  export default UserTable;
  
  